import { QWSService } from '../types/algorithm';

/**
 * Parses QWS dataset from CSV text format
 * Expected format: ResponseTime, Availability, Throughput, Successability, 
 * Reliability, Compliance, BestPractices, Latency, Documentation, ServiceName, WSDL_URL
 */
export function parseQWSDataset(csvText: string): QWSService[] {
  const lines = csvText.trim().split('\n');
  const services: QWSService[] = [];

  for (const line of lines) {
    if (!line.trim()) continue;

    const parts = line.split(',').map(p => p.trim());
    if (parts.length < 9) continue;

    try {
      const service: QWSService = {
        responseTime: parseFloat(parts[0]) || 0,
        availability: parseFloat(parts[1]) || 0,
        throughput: parseFloat(parts[2]) || 0,
        successability: parseFloat(parts[3]) || 0,
        reliability: parseFloat(parts[4]) || 0,
        compliance: parseFloat(parts[5]) || 0,
        bestPractices: parseFloat(parts[6]) || 0,
        latency: parseFloat(parts[7]) || 0,
        documentation: parseFloat(parts[8]) || 0,
        serviceName: parts[9] || '',
        wsdlUrl: parts[10] || '',
      };

      services.push(service);
    } catch (error) {
      console.warn('Failed to parse line:', line, error);
    }
  }

  return services;
}

/**
 * Builds quality matrix from QWS services and task count
 * Creates a 3D array: matrix[task][service][property]
 * This avoids Map size limits for large datasets
 */
export function buildQualityMatrix(
  services: QWSService[],
  taskCount: number
): number[][][] {
  // 3D array: [task][service][property]
  const matrix: number[][][] = [];

  for (let task = 0; task < taskCount; task++) {
    matrix[task] = [];
    for (let serviceIdx = 0; serviceIdx < services.length; serviceIdx++) {
      const service = services[serviceIdx];
      
      // Array of 9 properties: [responseTime, availability, throughput, ...]
      matrix[task][serviceIdx] = [
        service.responseTime,
        service.availability,
        service.throughput,
        service.successability,
        service.reliability,
        service.compliance,
        service.bestPractices,
        service.latency,
        service.documentation,
      ];
    }
  }

  return matrix;
}

